import styled from 'styled-components';

import { Avatar } from 'apps/components/shared';
import Button from 'components/Button';

export const AuthorAvatar = styled(Avatar)`
  margin-right: 10px;
  display: inline-block;
`;

export const FullName = styled.h4`
  margin: 2px 0px 0px 0px;
  display: inline-block;
  vertical-align: top;
`;

export const UsernameWrapper = styled.span`
  font-weight: ${props => props.theme.font.weight.xbold};
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonStyled = styled(Button)`
  margin-left: auto;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2rem;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
